/**
 * @generated SignedSource<<e61fe790bb6da7ef1275b7f1e218e1f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserEditFormDeleteMutation$variables = {
  id: string;
};
export type UserEditFormDeleteMutation$data = {
  readonly deleteOrganization: string;
};
export type UserEditFormDeleteMutation = {
  response: UserEditFormDeleteMutation$data;
  variables: UserEditFormDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteOrganization",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserEditFormDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserEditFormDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1ef6881a430f1514020c74af1ecfe66a",
    "id": null,
    "metadata": {},
    "name": "UserEditFormDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation UserEditFormDeleteMutation(\n  $id: ID!\n) {\n  deleteOrganization(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "e4dc19605acbe9571f0aa98380ff4559";

export default node;
